/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { mergeQueryKeys, getBaseQueryKey } from "../utils/queryKeyHelpers";

// Everything the Audit Logs page reads: the run list and the analytics cards above it. Both are
// stale after any import, so they are invalidated together -- invalidating only the list left the
// summary cards showing pre-import totals.
export const auditLogRefreshKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.audit_logs),
  getBaseQueryKey(Query_Keys.audit_logs_analytics)
);

// The Check-In Compliance table, its KPI cards and its row drill-ins are always invalidated together
// so the totals, the rows and the drill-in lists match.
export const checkInComplianceRefreshKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.check_in_compliance),
  getBaseQueryKey(Query_Keys.check_in_compliance_summary),
  getBaseQueryKey(Query_Keys.check_in_compliance_eligible_orders),
  getBaseQueryKey(Query_Keys.check_in_compliance_reconciled_check_ins)
);

// The Billing Report and its subtotal drill-down are invalidated together so the orders match the totals.
export const billingReportRefreshKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.billing_report),
  getBaseQueryKey(Query_Keys.billing_report_orders)
);

// The /admin/dropdowns rosters: active_users_list backs the "Select Employees" modal,
// active_guests_list backs the employee filters, and discount_card_variant_assignable_guests_list
// backs the special perq group "Assign Members" modal. Any employee or network guest change alters all three.
export const userDropdownRefreshKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.active_users_list),
  getBaseQueryKey(Query_Keys.active_guests_list),
  getBaseQueryKey(Query_Keys.discount_card_variant_assignable_guests_list)
);

export const subGroupDependentRefreshKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.employees),
  getBaseQueryKey(Query_Keys.network_guests),
  getBaseQueryKey(Query_Keys.employee_discount_report),
  getBaseQueryKey(Query_Keys.employee_discounts),
  getBaseQueryKey(Query_Keys.employee_discounts_analytics),
  getBaseQueryKey(Query_Keys.active_guests_list),
  getBaseQueryKey(Query_Keys.named_user_discounts)
);
